jQuery(function ($) {
   'use strict';

   // Applies only for mobile devices
    $('.hamburger-nav-menu').off("click").click(function (e) {
        e.preventDefault();
        e.stopPropagation();

        $(this).toggleClass('hamburger-nav-open nav-open');
        $(this).toggleClass('hamburger-nav-closed');
        $('body').toggleClass('mobile mobile-menu-opened');

        $('.shareBarBottom').toggle();
        $('.mobile-menu', '.header--mobile').toggleClass('pane-open');
        $('.mobileweb_bottom_floating').toggle();
        //force closing right menu in case it's opened
        var $editions = $('.editions-nav-menu');


        var hamburgerOpened = $(this).hasClass('nav-open');
        var editionsOpened = $editions.hasClass('nav-open');

        $('body').toggleClass('mobile-menu-opened', hamburgerOpened || editionsOpened);

        if (hamburgerOpened && editionsOpened) {
            $editions.toggleClass('nav-open');
            $('.editions-mobile').toggle();
        }
    });
});
